'use client';

import { gsap } from 'gsap';
import { useParams } from 'next/navigation';
import React, { FC, useEffect, useRef, useState } from 'react';

import { PartnerType } from '@/api/config/types';
import GlobalService from '@/api/services/GlobalService';
import { useTranslation } from '@/hooks/useTranslations';

import Image from '../core/Image';

import './styles.scss';

const TrustedPartners: FC = () => {
  const [forMarquee, setForMarquee] = useState<PartnerType[]>();
  const { t } = useTranslation();
  const params = useParams();

  const sliderLeftRef = useRef<HTMLDivElement>(null);
  const sliderRightRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    GlobalService.getData<PartnerType>('PARTNERS_URL', {
      lang: params.lang,
    }).then((data) => {
      setForMarquee(
        data?.query
          .concat(data.query)
          .concat(data.query)
          .concat(data.query)
          .concat(data.query)
          .concat(data.query)
      );
    });
  }, []);

  useEffect(() => {
    if (!forMarquee) return;
    const sliderLeft = sliderLeftRef.current;
    const sliderRight = sliderRightRef.current;

    if (sliderLeft && sliderRight) {
      const leftImages = sliderLeft.querySelectorAll('.imgLogoSlider');
      const rightImages = sliderRight.querySelectorAll('.imgLogoSlider');

      leftImages.forEach((image) => {
        gsap.set(image, {
          x: (i) => i * 225,
        });
        gsap.to(image, {
          x: '+=24300',
          ease: 'linear',
          repeat: -1,
          duration: 1000,
          modifiers: {
            x: gsap.utils.unitize((x) => parseFloat(x) % 24300),
          },
        });
      });

      rightImages.forEach((image) => {
        gsap.set(image, {
          x: (i) => i * 225,
        });
        gsap.to(image, {
          x: '-=24300',
          ease: 'linear',
          repeat: -1,
          duration: 1000,
          modifiers: {
            x: gsap.utils.unitize((x) => parseFloat(x) % 24300),
          },
        });
      });
    }
  }, [forMarquee]);

  return (
    <div className="ourTrustedWrpInner" id="partners">
      <div className="ourTrustedTitleRow">
        <h3 className="ourTrustedTitleText">{t('Homepage-Partners')}</h3>
      </div>
      {forMarquee && (
        <div className="bottomSliderWrapper">
          <div className="bottomLogoSlider" ref={sliderRightRef}>
            <div className="bottomLogoSliderInner">
              {forMarquee.map((partner, index) => (
                <Image
                  width={225}
                  height={30}
                  alt="partners"
                  src={partner.logo}
                  key={`${partner.partnerName}-${index}`}
                  className={`imgLogoSlider ${partner.partnerName}`}
                />
              ))}
            </div>
          </div>
          <div className="bottomLogoSlider" ref={sliderLeftRef}>
            <div className="bottomLogoSliderInner">
              {forMarquee.map((partner, index) => (
                <Image
                  width={225}
                  height={30}
                  alt="partners"
                  src={partner.logo}
                  key={`${index}-${partner.partnerName}`}
                  className={`imgLogoSlider ${partner.partnerName}`}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrustedPartners;
